<template>
  <div class="container notFoundContainer">
    <h1 class="first-four">4</h1>
    <div class="cog-wheel1">
        <div class="cog1">
          <div class="top topNotFound"></div>
          <div class="down downNotFound"></div>
          <div class="left-top"></div>
          <div class="left-down"></div>
          <div class="right-top"></div>
          <div class="right-down"></div>
          <div class="left leftNotFound"></div>
          <div class="right rightNotFound"></div>
      </div>
    </div>
    
    <!-- <div class="cog-wheel2"> 
      <div class="cog2">
          <div class="topNotFound"></div>
          <div class="downNotFound"></div>
          <div class="left-top"></div>
          <div class="left-down"></div>
          <div class="right-top"></div>
          <div class="right-down"></div>
          <div class="leftNotFound"></div>
          <div class="rightNotFound"></div>
      </div>
    </div> -->
   <h1 class="second-four">4</h1>
    <p class="wrong-para">{{$t('notFound')}}</p>
  </div>
</template>

<style>
.notFoundContainer{
  width:100vw;
  height:100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  left:6vmin;
  text-align: center;
}

.cog-wheel1, .cog-wheel2{
  transform:scale(0.7);
}

.cog1{
  bottom:10vmin;
  right: 15%;
}

.cog1, .cog2{
  width:40vmin;
  height:40vmin;
  border-radius:50%;
  border:6vmin solid #f3c623;
  position: relative;
}


.cog2{
  border:6vmin solid #B5AAA3;
}

.topNotFound, .downNotFound, .leftNotFound, .rightNotFound, .left-top, .left-down, .right-top, .right-down{
  width:10vmin;
  height:10vmin;
  background-color: #f3c623;
  position: absolute;
}

.cog2 .topNotFound,.cog2  .downNotFound,.cog2  .leftNotFound,.cog2  .rightNotFound,.cog2  .left-top,.cog2  .left-down,.cog2  .right-top,.cog2  .right-down{
  background-color: #B5AAA3;
}

.topNotFound{
  top:-14vmin;
  left:9vmin;
}

.downNotFound{
  bottom:-14vmin;
  left:9vmin;
}

.leftNotFound{
  left:-14vmin;
  top:9vmin;
}

.rightNotFound{
  right:-14vmin;
  top:9vmin;
}

.left-top{
  transform:rotateZ(-45deg);
  left:-8vmin;
  top:-8vmin;
}

.left-down{
  transform:rotateZ(45deg);
  left:-8vmin;
  top:25vmin;
}

.right-top{
  transform:rotateZ(45deg);
  right:-8vmin;
  top:-8vmin;
}

.right-down{
  transform:rotateZ(-45deg);
  right:-8vmin;
  top:25vmin;
}

.cog2{
  position: relative;
  left:-10.2vmin;
  bottom:10vmin;
}


.first-four{
  position: relative;
  left:6vmin;
  font-size:40vmin;
}

.second-four{
  position: relative;
  right:18vmin;
  z-index: -1;
  color:#232323;
  font-size:40vmin;
}

.wrong-para{
  position: absolute;
  bottom:15vmin;
  padding:3vmin 12vmin 3vmin 3vmin;
  font-weight:600;
  color:#232323;
}
</style>

<script>
import { gsap } from 'gsap';

export default {
  name: 'AnimationComponent',
  mounted() {
    this.setupAnimations();
  },
  methods: {
    setupAnimations() {
      const t1 = gsap.timeline({ repeat: -1 });
      const t2 = gsap.timeline({ repeat: -1 });
      const t3 = gsap.timeline();

      t1.to('.cog1', {
        transformOrigin: '50% 50%',
        rotation: '+=360',
        ease: 'none',
        duration: 8,
      });

      t2.to('.cog2', {
        transformOrigin: '50% 50%',
        rotation: '-=360',
        ease: 'none',
        duration: 8,
      });

      t3.fromTo(
        '.wrong-para',
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 1,
          stagger: {
            repeat: -1,
            yoyo: true,
          },
        }
      );
    },
  },
};
</script>
